import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Cookies from "js-cookie";
import SweetAlert from "../../Landing/Components/SweetAlert/SweetAlert";
import { fetchData } from "./Utilities";
import Form from "react-bootstrap/Form";
const OutComeCoinModal = ({ isOpen, closeModal, onExit, onExited, userId }) => {
  const [mob, setMob] = useState({ value: "", error: null });
  const [coin, setCoin] = useState({ value: 0, error: null });

  const saveCoins = async () => {
    if (!coin.value) {
      setCoin({
        value: coin.value,
        error: "لطفا تعداد سکه ها را وارد نمایید.",
      });
      return;
    }
    if (!mob.value) {
      setMob({ value: mob.value, error: "لطفا شماره موبایل را وارد کنید" });
      return;
    }
    setCoin({ value: coin.value, error: "" });
    setMob({ value: mob.value, error: "" });
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    bodyFormData.append("coin", coin.value);
    bodyFormData.append("mob", mob.value);
    fetchData("outcomecoin", bodyFormData, handleApiResponse);
  };
  const handleApiResponse = (data) => {
    closeModal();
    SweetAlert({
      title: "",
      text: data.msg,
      type: `${data.code === 0 ? "failed" : "success"}`,
    });
  };

  return (
    <Modal
      show={isOpen}
      onHide={closeModal}
      onExit={onExit}
      onExited={onExited}
      centered
    >
      <Modal.Header>
        
      <div className="m-auto maxh-20 fw-bold text-secondary ">
      پرداخت سکه به کاربر
      </div>

          <button className="btn-close bg-danger text-white" onClick={() => closeModal()} />
      
      </Modal.Header>
      <Modal.Body
        className="justify-content-center mx-4
            "
      >
        <>
          <Form.Group className="mb-3 w-75">
            <Form.Label className="fw-bold pb-1">تعداد سکه ها</Form.Label>
            <Form.Control
              type="number"
              onChange={(e) => setCoin({ value: e.target.value, error: "" })}
            />
            {coin.error && (
              <p className="text-danger text-center">{coin.error}</p>
            )}
          </Form.Group>
          <Form.Group className="mb-3 w-75">
            <Form.Label className="fw-bold pb-1">شماره موبایل کاربر</Form.Label>
            <Form.Control
              type="number"
              onChange={(e) => setMob({ value: e.target.value, error: "" })}
            />
            {mob.error && (
              <p className="text-danger text-center">{mob.error}</p>
            )}
          </Form.Group>
        </>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button variant="primary" onClick={() => saveCoins()}>
          ذخیره
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OutComeCoinModal;
